import React from 'react';
import PropTypes from 'prop-types';
import nookies from 'nookies';

import BoardsProvider from '/imports/job-tracking/api/context/boards.context';
import CancelSubscriptionForm from '/imports/core/ui/components/CancelSubscriptionForm';
import GeneralProvider from '/imports/job-tracking/api/context/general.context';
import { getBoardList } from '/imports/job-tracking/api/api';
import HeaderSkeleton from '/imports/dashboard/ui/skeleton/HeaderSkeleton';
import { isJobTrackEnable } from '/lib/helpers';
import SearchProvider from '/imports/job-tracking/api/context/search.context';
import useMountedState from '/imports/core/api/useMountedState';
import withAccountInfo from '/imports/core/api/accounts/withAccountInfo';
import CancelSubscriptionLayout from 'imports/core/ui/layout/CancelSubscriptionLayout';

const CancelSubscription = ({ pageProps: { boards } }) => {
  const { renderIfMounted } = useMountedState();
  const renderCancelSubLayout = () => {
    if (isJobTrackEnable()) {
      return (
        <GeneralProvider>
          <BoardsProvider boards={boards}>
            <SearchProvider>
              <CancelSubscriptionLayout>
                <CancelSubscriptionForm />
              </CancelSubscriptionLayout>
            </SearchProvider>
          </BoardsProvider>
        </GeneralProvider>
      );
    } else {
      return (
        <CancelSubscriptionLayout>
          <CancelSubscriptionForm />
        </CancelSubscriptionLayout>
      );
    }
  };
  return renderIfMounted(renderCancelSubLayout());
};

CancelSubscription.propTypes = {
  pageProps: PropTypes.shape({
    boards: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  }),
};

CancelSubscription.getInitialProps = async (context) => {
  if (isJobTrackEnable()) {
    try {
      const { token } = nookies.get(context);
      const res = await Promise.all([getBoardList(token)]);
      return {
        boards: res[0],
      };
    } catch (e) {
      return { boards: [] };
    }
  }
};

export default withAccountInfo(CancelSubscription, HeaderSkeleton);
